import React from "react";
import values from "lodash/values";
import pick from "lodash/pickBy";
import {
  RaisedButton,
  FlatButton,
  LinearProgress,
  Checkbox,
  Dialog,
  TextField,
  MenuItem
} from "material-ui";
import LinkIcon from "material-ui/svg-icons/content/link";
import juration from "juration";
import moment from "moment";

import connectToStores from "alt-utils/lib/connectToStores";
import VirtualContentActions from "../../actions/VirtualContentActions";
import VirtualContentStore from "../../stores/VirtualContentStore";
import VirtualContentUtil from "../../utils/VirtualContentUtil";
import UserStore from "../../stores/UserStore";

import WorkingIndicator from "./working-indicator.jsx";
import LinkLike from "./link-like.jsx";
import SelectField from "./select-field.jsx";
import InlineNoticeLabel from "./inline-notice-label.jsx";

import { formatBytes } from "../../util";

import Evaporate from "evaporate";
import sparkMD5 from "spark-md5";
import sha256 from "js-sha256";
import qs from "query-string";

const parsedQueryString = qs.parse(window.location.search);

const THREESIXTY_VR_ENABLED = true;
const GOOGLE_DRIVE_ENABLED = false;

class VirtualContentUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      needsTosConfirm: false,
      completed: false,
      virtualContentId: null,
      file: null,
      progressStats: null,
      isDropboxUploadFromLink: null,

      showUrlEntry: false,
      urlEntered: "",

      asset_pathway:
        parsedQueryString.asset_pathway === "legacy"
          ? ""
          : parsedQueryString.asset_pathway || "ev_next",
      source_video_layout: parsedQueryString.source_video_layout || undefined,
      source_audio_layout: parsedQueryString.source_audio_layout || undefined
    };
  }

  static getStores() {
    return [VirtualContentStore];
  }

  static getPropsFromStores() {
    return VirtualContentStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  componentDidMount() {
    // Inject dropbox uploader
    if (!document.getElementById("dropboxjs")) {
      const script = document.createElement("script");
      script.id = "dropboxjs";
      script.src = "https://www.dropbox.com/static/api/2/dropins.js";
      script.setAttribute("data-app-key", "g65s6evybsoyska");
      document.body.appendChild(script);
    }

    // Inject Google Drive uploader
    if (GOOGLE_DRIVE_ENABLED && !document.getElementById("googleapi")) {
      window.onGoogleApiLoad = () => {
        window.gapi.load("auth2");
        window.gapi.load("picker");
        window.gapi.client.load("drive", "v2");
      };
      const googleScript = document.createElement("script");
      googleScript.id = "googleapi";
      googleScript.src =
        "https://apis.google.com/js/api.js?onload=onGoogleApiLoad";
      document.body.appendChild(googleScript);
    }

    if (!this.props.noFetchOther) {
      VirtualContentActions.fetchAll.defer();
    }
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.isCreating && newProps.newVirtualContentId) {
      this.setState(
        {
          virtualContentId: newProps.newVirtualContentId
        },
        () => {
          this.upload();
        }
      );
    }
  }

  onSuccess() {
    this.setState({ completed: true }, () => {
      if (this.props.onSuccess) {
        this.props.onSuccess(
          VirtualContentStore.getVirtualContentById(this.state.virtualContentId)
        );
      } else {
        window.alert("Upload successful!");
      }
    });
  }

  _fetchDestinationFilename() {
    return fetch(
      `${process.env.CINESEND_API_ENDPOINT}/videos/${this.state.cinesendVideoId}/upload-destination?fileName=${this.state.file.name}&fileSize=${this.state.file.size}&apiKey=${process.env.CINESEND_API_KEY}`
    )
      .then(r => r.json())
      .then(d => d.destination);
  }

  _fetchSignatureFromCinesend(
    signParams,
    signHeaders,
    stringToSign,
    signatureDateTime,
    canonicalRequest
  ) {
    return fetch(
      `${process.env.CINESEND_API_ENDPOINT}/videos/${this.state.cinesendVideoId}/upload-signature?to_sign=${stringToSign}&datetime=${signatureDateTime}&apiKey=${process.env.CINESEND_API_KEY}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
      .then(data => data.json())
      .then(d => d.signature);
  }
  _fetchSignatureFromEventive(
    signParams,
    signHeaders,
    stringToSign,
    signatureDateTime,
    canonicalRequest
  ) {
    return VirtualContentUtil.uploadSignature(
      UserStore.getState().apiKey,
      this.state.virtualContentId,
      {
        to_sign: decodeURIComponent(stringToSign),
        datetime: signatureDateTime,
        canonical_request: canonicalRequest
      }
    ).then(e => e.signature);
  }

  dropboxUpload() {
    Dropbox.choose({
      success: files => {
        let { bytes, name, link } = files[0];

        if (!link) {
          window.alert(
            `[Panic] Failed to retrieve file from Dropbox successfully. Payload received: ${JSON.stringify(
              files
            )}`
          );
          return;
        }

        this.setState({
          needsTosConfirm: true,
          file: {
            name: name,
            size: bytes,
            directSourceLink: link
          }
        });
      },
      cancel: function () {},
      linkType: "direct",
      multiselect: false,
      extensions: ["video"],
      folderselect: false
    });
  }

  googleDriveUpload() {
    if (!this.state.googleOauthToken) {
      window.gapi.auth2
        .init({
          client_id:
            "888211540537-ecmrmu3l18t0457e5kgkeehus01tchau.apps.googleusercontent.com"
        })
        .then(() => {
          window.gapi.auth2
            .getAuthInstance()
            .signIn({
              scope: "https://www.googleapis.com/auth/drive.readonly"
            })
            .then(res => {
              let { access_token } = res.getAuthResponse(true);
              this.setState({ googleOauthToken: access_token }, () =>
                this.googleDriveUpload()
              );
            });
        });
      return;
    }

    const picker = new google.picker.PickerBuilder()
      .addView(google.picker.ViewId.DOCS_VIDEOS)
      .setOAuthToken(this.state.googleOauthToken)
      .setDeveloperKey("AIzaSyA_htjtfZLJ7pYQd2GmE7ub8_hvZX7B8LE")
      .setCallback(data => {
        if (data.action == google.picker.Action.PICKED) {
          const request = window.gapi.client.drive.files.get({
            fileId: data.docs[0].id
          });
          request.execute(resp => {
            console.log(resp.downloadUrl);
            this.setState({
              needsTosConfirm: true,
              file: {
                name: resp.title,
                size: resp.fileSize,
                directSourceLink: `GOOGLEDRIVE_${JSON.stringify({
                  url: resp.downloadUrl,
                  oauth_token: this.state.googleOauthToken
                })}`
              }
            });
          });
        }
      })
      .build();
    picker.setVisible(true);
  }

  async urlUpload() {
    if (!this.state.showUrlEntry) {
      this.setState({ showUrlEntry: true });
      return;
    }

    let { urlEntered } = this.state;

    const vimeoMatch =
      urlEntered.indexOf("vimeo.com") !== -1 &&
      urlEntered.indexOf("download") === -1;
    if (vimeoMatch) {
      this.setState({
        vimeoInvalid: true
      });
      return;
    }

    let chunks = urlEntered.split("/");
    this.setState({
      vimeoInvalid: false,
      showUrlEntry: false,
      needsTosConfirm: true,
      file: {
        name: chunks[chunks.length - 1],
        directSourceLink: urlEntered
      }
    });
  }

  create() {
    if (!this.state.file && (!this.input || !this.input.files.length)) {
      return;
    }

    if (!this.state.needsTosConfirm) {
      const file = this.input.files[0];
      this.setState({ needsTosConfirm: true, tosAgreed: false, file });
      return;
    }

    this.setState({ needsTosConfirm: false });

    let { file } = this.state;

    VirtualContentActions.create(
      Object.assign(
        {
          type: "vod",
          label: file.name,
          file_size: file.size,
          ams_drm_enabled: true,
          asset_pathway: this.state.asset_pathway || undefined,
          source_video_layout: this.state.source_video_layout || undefined,
          source_audio_layout: this.state.source_audio_layout || undefined,
          source_upload_url: file.directSourceLink
        },
        this.props.filmId && {
          _films: [this.props.filmId]
        }
      )
    );
  }

  async upload() {
    // Direct source = instant success
    if (this.state.file && this.state.file.directSourceLink) {
      this.onSuccess();
      return;
    }

    try {
      this.setState({ progressStats: {} });

      const evaporate = await Evaporate.create({
        aws_key: process.env.MEZZANINE_AWS_ACCESS_KEY_ID,
        bucket: process.env.MEZZANINE_AWS_BUCKET_NAME,
        cloudfront: true,
        s3Acceleration: true,
        computeContentMd5: true,
        s3FileCacheHoursAgo: 6,
        onlyRetryForSameFileName: true,
        cryptoMd5Method: d => btoa(sparkMD5.ArrayBuffer.hash(d, true)),
        cryptoHexEncodedHash256: d => sha256(d),
        customAuthMethod: this._fetchSignatureFromEventive.bind(this)
      });

      const awsKey = evaporate.add({
        name: this.state.virtualContentId,
        file: this.state.file,
        progress: (p, progressStats) => this.setState({ progressStats }),
        complete: (_xhr, awsKey) => this.onSuccess(awsKey)
      });
    } catch (e) {
      console.error(e);
      window.alert(`Upload failed: ${e.message}`);
    }
  }

  render() {
    const {
      showUrlEntry,
      urlEntered,
      needsTosConfirm,
      completed,
      progressStats
    } = this.state;

    const otherVirtualContent = VirtualContentStore.getVirtualContent()
      .filter(
        c =>
          (!this.props.existingVirtualContentId ||
            c.id !== this.props.existingVirtualContentId) &&
          c.status === "ready" &&
          c.type === "vod" &&
          c.platform !== "cinesend" && // Cinesend assets deprecated
          c.platform !== "eventive" // AMS assets deprecated
      )
      .filter(c => {
        if (this.state.otherContentSearch) {
          return (
            (c.label || "")
              .toLowerCase()
              .indexOf(this.state.otherContentSearch.toLowerCase()) !== -1
          );
        }
        return true;
      })
      .sort((a, b) => b.created_at.localeCompare(a.created_at));

    const invalid = this.urlField && !this.urlField.input.checkValidity();

    return (
      <div>
        <Dialog
          title="Direct URL upload"
          modal={false}
          open={!!showUrlEntry}
          actions={[
            <FlatButton
              onClick={() => this.setState({ showUrlEntry: false })}
              label="Cancel"
            />,
            <FlatButton
              primary={true}
              disabled={!urlEntered || invalid}
              onClick={() => this.urlUpload()}
              label="Confirm"
            />
          ]}
          onRequestClose={() => this.setState({ showUrlEntry: false })}
        >
          <div>
            You can upload an asset directly from a URL. Ensure the URL points
            directly to a downloadable video file (typically ending in .mp4 or
            .mov)&mdash;links to intermediate pages will not work.
          </div>
          <TextField
            ref={r => {
              this.urlField = r;
            }}
            floatingLabelFixed
            floatingLabelText="Fully-qualified URL"
            placeholder="https://example.com/video.mp4"
            value={urlEntered}
            autoFocus
            style={{ width: 400 }}
            type="url"
            onChange={e =>
              this.setState({ urlEntered: e.target.value, vimeoInvalid: false })
            }
          />
          {this.state.vimeoInvalid ? (
            <p>
              Vimeo URLs cannot be used to upload directly due to Vimeo security
              limitations. If the uploader is a Vimeo Plus member or higher and
              has enabled downloads for the video, you can{" "}
              <a
                href="https://vimeo.zendesk.com/hc/en-us/articles/229678128-Download-videos"
                target="_blank"
              >
                download the source file from Vimeo
              </a>
              , then upload it to Eventive.
            </p>
          ) : invalid ? (
            <p>Please enter a valid URL (including "https://") to continue.</p>
          ) : null}
        </Dialog>
        {needsTosConfirm ? (
          <div
            style={{
              border: "1px dashed #0288d1",
              borderRadius: "0.5em",
              padding: 20,
              textAlign: "left"
            }}
          >
            <div
              style={{
                marginTop: "-0.5em",
                marginBottom: 20,
                display: "flex"
              }}
            >
              {THREESIXTY_VR_ENABLED ? (
                <div style={{ flex: "1 0 0", marginRight: 10 }}>
                  <SelectField
                    value={this.state.source_video_layout || "default"}
                    onChange={v =>
                      this.setState({
                        source_video_layout:
                          v.value === "default" ? undefined : v.value
                      })
                    }
                    label={
                      <span>
                        Video layout{" "}
                        <a
                          href="https://help.eventive.org/en/articles/5331073-video-specifications-for-eventive-virtual"
                          target="_blank"
                        >
                          (?)
                        </a>
                      </span>
                    }
                    options={[
                      { value: "default", label: "Default" },
                      {
                        value: "360_single",
                        label: "360°/VR"
                      }
                    ]}
                    clearable={false}
                  />
                </div>
              ) : null}
              <div style={{ flex: "1 0 0" }}>
                <SelectField
                  value={this.state.source_audio_layout || "default"}
                  onChange={v =>
                    this.setState({
                      source_audio_layout:
                        v.value === "default" ? undefined : v.value
                    })
                  }
                  label={
                    <span>
                      Audio layout{" "}
                      <a
                        href="https://help.eventive.org/en/articles/5134510-audio-specifications-for-eventive-virtual"
                        target="_blank"
                      >
                        (?)
                      </a>
                    </span>
                  }
                  options={[
                    {
                      value: "default",
                      label: parsedQueryString.audio_beta ? "Stereo" : "Default"
                    },
                    {
                      value: "default_with_audio_description",
                      label: parsedQueryString.audio_beta
                        ? "Stereo + Audio Description"
                        : "Default + Descriptive Audio"
                    }
                  ].concat(
                    parsedQueryString.audio_beta
                      ? [
                          {
                            value: "5_1_surround",
                            label:
                              "5.1 Surround + Stereo (+ Optional Audio Description)"
                          },
                          {
                            value: "5_1_surround_legacy",
                            label: '"8-Track"/"8-Channel" 5.1 Surround + Stereo'
                          }
                          // { value: "atmos", label: "Dolby Atmos" }
                        ]
                      : []
                  )}
                  clearable={false}
                />
              </div>
            </div>
            <Checkbox
              labelStyle={{ lineHeight: 1.2 }}
              inputStyle={{ width: 50 }}
              label={
                <span>
                  I agree that I am authorized to upload the video content{" "}
                  <span style={{ wordBreak: "break-all" }}>
                    "{this.state.file.name}"
                  </span>{" "}
                  in accordance with the Eventive{" "}
                  <a
                    target="_blank"
                    href="https://eventive.org/terms"
                    onClick={e => e.stopPropagation()}
                  >
                    Terms of Service
                  </a>
                  .
                  {UserStore.isGod() && this.state.asset_pathway
                    ? ` (pathway: ${this.state.asset_pathway})`
                    : ""}
                </span>
              }
              checked={this.state.tosAgreed}
              onCheck={() =>
                this.setState({ tosAgreed: !this.state.tosAgreed })
              }
            />
            <div style={{ marginTop: 20, textAlign: "center" }}>
              <RaisedButton
                label="Begin upload"
                primary
                disabled={!this.state.tosAgreed}
                onClick={() => this.create()}
              />
            </div>
          </div>
        ) : progressStats ? (
          <div
            style={{
              textAlign: "center"
            }}
          >
            <div>
              {completed
                ? "Content uploaded"
                : `Content uploading @ ${
                    (progressStats.readableSpeed || "").toUpperCase() || "0 KB"
                  }/s`}
            </div>
            <LinearProgress
              mode="determinate"
              max={1}
              value={
                (progressStats.totalUploaded || 0) /
                (progressStats.fileSize || this.state.file.size)
              }
              style={{
                height: "1em",
                borderRadius: "0.5em",
                margin: "0.5em 0 0.25em"
              }}
            />
            <div style={{ textAlign: "right", fontSize: "0.8em" }}>
              {progressStats.secondsLeft && progressStats.secondsLeft > 0
                ? juration.stringify(progressStats.secondsLeft, {
                    format: "short"
                  })
                : "∞ hrs"}{" "}
              remaining &middot; {formatBytes(progressStats.totalUploaded || 0)}{" "}
              / {formatBytes(progressStats.fileSize || this.state.file.size)}
            </div>
          </div>
        ) : (
          <div>
            <p style={{ textAlign: "center" }}>
              <RaisedButton
                label={
                  this.props.isCreating
                    ? "Initializing upload..."
                    : "Upload content"
                }
                primary
                containerElement="label"
                disabled={this.props.isCreating}
              >
                <input
                  type="file"
                  accept=".mov,.mp4"
                  style={{ display: "none" }}
                  ref={ref => {
                    this.input = ref;
                  }}
                  onChange={() => this.create()}
                />
              </RaisedButton>
              {!this.props.isCreating ? (
                <div>
                  <div
                    style={{
                      marginTop: "1em",
                      fontSize: "1em",
                      display: "inline-flex"
                    }}
                  >
                    <FlatButton
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                        color: "#424242",
                        border: "1px solid #ccc",
                        borderRadius: "3px",
                        padding: "6px 8px",
                        height: "auto",
                        lineHeight: "1"
                      }}
                      onClick={e => {
                        this.dropboxUpload();
                      }}
                    >
                      <span
                        style={{
                          background:
                            "transparent url('https://www.dropbox.com/static/images/widgets/dbx-saver-status.png') no-repeat",
                          width: 15,
                          height: 14,
                          display: "inline-block",
                          verticalAlign: -1,
                          marginRight: 4
                        }}
                      ></span>
                      Dropbox
                    </FlatButton>

                    <FlatButton
                      style={{
                        marginLeft: "1em",
                        display: "inline-block",
                        cursor: "pointer",
                        color: "#424242",
                        border: "1px solid #ccc",
                        borderRadius: "3px",
                        padding: "6px 8px",
                        height: "auto",
                        lineHeight: "1"
                      }}
                      onClick={e => {
                        this.urlUpload();
                      }}
                    >
                      <LinkIcon
                        style={{
                          width: 16,
                          height: 16,
                          margin: "-3px 0px"
                        }}
                      />{" "}
                      From URL
                    </FlatButton>

                    {GOOGLE_DRIVE_ENABLED ? (
                      <FlatButton
                        style={{
                          marginLeft: "1em",
                          display: "inline-block",
                          cursor: "pointer",
                          color: "#424242",
                          border: "1px solid #ccc",
                          borderRadius: "3px",
                          padding: "6px 8px",
                          height: "auto",
                          lineHeight: "1"
                        }}
                        onClick={e => {
                          this.googleDriveUpload();
                        }}
                      >
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAIRlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAABSgAwAEAAAAAQAAABQAAAAAQeed/gAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAABFdJREFUOBGdVE1oXFUUPvfnvTczyUymSdMaUgihRWrTKjHFgjVgNsVuGloyARelWtFq6cJu+oMLR6wpiMSCqwZEqlVLxvqHuqhIi+hCSCptmUJBJMWaNCZtJjOZn/fuz/HcSTQpZuVh3r1v7jvnu+f7zrkXYBVDRLbK8gNLiLCqj3zAi/44RzK8fPm59I61elccDADnFtxsLQdkCA1NlxgbmV/0BVyJ8R/AXC7DAXKmbzJ5YrI9PB7352gX4bYiTMJd4wNM3h+ihddgyXcl4ANpZ0YzIjeYM8e+efWRtwvR9QOiJs9uvh8GAqUlLM5QA7MBWqEYS25jj52/hRTDKOYfUMpm2XI3u+rpf7sQnepNCXmu6oU/TCcC4HUZ3OYBUQ5ZE/cAyqcWI3PLAPT2L2DXaMaHbNZ2XziyuyZhX6EU2uYAg5PTMZgpk6rcMCqWYx7AvLIQmAG8MbCLDYLJ5yl2yRYBs1meH8xFbm3Bqrdc1Bxa3MQsXDfSfj7dyBazBCLuQAmZ02wjpyV0deUixGwdqz5sar5HFOjDhcNHTEx066qytCCmLUZdLR5/+a/YeVD2Y2jyyB8jYFSlClUoAT14rf+wi4XffqljsJ6zL3njh0ZU7+jJ1j+j2V+NB+2orHGCWc5EyqLKzyQ7cHee2ap/m0uQoHGxCAEICOFOyTR1p7Z/OotjPR4fXzNHNACm1OwJk5DtNjSKGAl6tEh4UDU4BEfPTLHN308C2tOQpBZiVgMaAtMKmtiGpCgcdxjQM27rbbP1k1ceLZpwjNLymK3vbkQi5rMy/NFS6318bM2zcyQ+XP3uveZt6368KlNig11QpBsIIUFYA9F8rWt785Nv3qgDdnz4wkXdKPdhKQzpQPlUAYbSwKQ51w/74ev67ksD5qEf2MNfgnbELALqCNLxAEq3LrKtMMA6Pzq4J/T4VyZUhrtaIpU2xoRfjV/dOTWcgRhA1YtkJzXGT2FS+dTaXzzx+mfpRt1drminJYUZG483iKnC+j2yqtQ80hGl6glrmaWOE7pWhI47e7eUILpGywIrHG9VGLTxCqsaZg7+fEymiYEhyoyENciFJIhOea9Yp7z+g/0jLBW8CEUdKlkKWgrd2P77APNb20EElKJraDIiCJLyqRDdorZIGCQ5hEFDLLhZqI3MvRE/5FIj2dSQLYYF62EgtBc1T+5gTCasqpaUDqva6EhrFWpLc6hCFcfIttFxXid01BbwIF0tFg6k7552WBwuZ+Xd5y9McOO/W4vPwdqZp2ys0qnQF5QPY9Youq+ICGlBkxtYRFdYFYWqIcdI+rBg7PCZo50TT2fRMb/igOHuxveHk1Mbb7fWnomJZIsnYk1CxtJS+Ckh/IQUQYNwD196517C85OJICoVJ4L5cLgOQoOEvis6kxkVub7BhbUndu7V5coWG+ch16S3EPSjRhbu7Ls7cdncVRuVbUDNnb/0zkPlOkaW6WWPrNP4/1l2Rezfu3EQlpGX0OUAAAAASUVORK5CYII="
                          style={{
                            width: 15,
                            height: 15,
                            display: "inline-block",
                            verticalAlign: -2,
                            marginRight: 4
                          }}
                        />
                        Google Drive
                      </FlatButton>
                    ) : null}
                  </div>
                </div>
              ) : null}
              <div
                style={{
                  marginTop: "1em",
                  fontSize: "0.75em",
                  lineHeight: 1.25
                }}
              >
                10 GB maximum file size
                <br />
                1080p resolution recommended
                <br />
                .mov, .mp4 accepted
              </div>
            </p>
            {otherVirtualContent.length || this.state.otherContentSearch ? (
              <div style={this.props.otherContentStyle}>
                {this.props.otherContentIntroduction}
                <div
                  style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: this.props.otherContentIntroduction ? 10 : 0,
                    width: 200
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search existing content..."
                    value={this.state.otherContentSearch}
                    onChange={e => {
                      this.setState({ otherContentSearch: e.target.value });
                    }}
                    style={{
                      border: "1px solid #ccc",
                      padding: "2px 5px",
                      borderRadius: 5,
                      width: "100%",
                      boxSizing: "border-box"
                    }}
                  />
                </div>
                <div
                  style={{
                    maxHeight: this.props.otherContentIntroduction ? 205 : 115,
                    overflowY: "auto",
                    margin: "1em 0"
                  }}
                >
                  {this.state.otherContentSearch &&
                  otherVirtualContent.length === 0 ? (
                    <div
                      style={{
                        fontSize: "0.8em",
                        textAlign: "center"
                      }}
                    >
                      No matches found
                    </div>
                  ) : (
                    <table
                      className="hoverable"
                      style={{ borderCollapse: "collapse", minWidth: 300 }}
                    >
                      <tbody>
                        {otherVirtualContent.map(content => (
                          <tr
                            key={content.id}
                            className=""
                            style={{
                              fontSize: "0.8em"
                            }}
                          >
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderBottom: "1px solid #ccc",
                                wordBreak: "break-word",
                                lineHeight: "1.2"
                              }}
                            >
                              {content.label || "Unlabeled content"}
                              {content.platform && UserStore.isGod()
                                ? ` (${content.platform})`
                                : ""}
                              <div
                                style={{
                                  fontSize: "0.8em",
                                  marginTop: 2,
                                  opacity: 0.6
                                }}
                              >
                                Uploaded{" "}
                                {moment(content.created_at).format("ll")}{" "}
                                &middot;{" "}
                                {content.duration
                                  ? juration.stringify(
                                      content.duration / 1000,
                                      { format: "short" }
                                    )
                                  : "Still processing"}
                              </div>
                            </td>
                            <td
                              style={{
                                whiteSpace: "nowrap",
                                borderTop: "1px solid #ccc",
                                borderBottom: "1px solid #ccc"
                              }}
                            >
                              <LinkLike
                                onTouchTap={() => {
                                  if (this.props.onOtherContentSelect) {
                                    this.props.onOtherContentSelect(content);
                                  } else {
                                    this.props.onSuccess(content);
                                  }
                                }}
                              >
                                {this.props.otherContentIntroduction
                                  ? `Use this content`
                                  : `Use`}
                              </LinkLike>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default connectToStores(VirtualContentUploader);



// WEBPACK FOOTER //
// ./src/app/components/partials/virtual-content-uploader.jsx